import { render, staticRenderFns } from "./MobileVerification.vue?vue&type=template&id=d33810b6&scoped=true"
import script from "./MobileVerification.vue?vue&type=script&lang=js"
export * from "./MobileVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33810b6",
  null
  
)

export default component.exports